import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Slide1() {
  return <div className="slide-content" data-id="element-8">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-9">
        <h1 className="slide-headline" data-id="element-10">
          Fast. Good. Cheap.{' '}
          <span className="text-text-muted font-normal" data-id="element-11">
            — You usually pick two.
          </span>
        </h1>
      </motion.div>

      <div className="flex-1 grid grid-cols-2 gap-16 mt-8 items-center" data-id="element-12">
        {/* Left Side: Today */}
        <motion.div className="space-y-12" initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-13">
          <h2 className="text-2xl font-semibold text-text-muted mb-6 uppercase tracking-wider text-sm" data-id="element-14">
            Today
          </h2>

          <div className="bg-card-bg p-8 rounded-xl border border-gray-100 relative overflow-hidden" data-id="element-15">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-gray-300" data-id="element-16"></div>
            <h3 className="text-xl font-bold mb-4" data-id="element-17">Agency</h3>
            <div className="flex items-center text-lg text-text-muted" data-id="element-18">
              <span className="font-medium text-text-main mr-2" data-id="element-19">Good</span>, but
              slow & expensive
              <X className="w-5 h-5 text-roche-red ml-3" strokeWidth={3} data-id="element-20" />
            </div>
          </div>

          <div className="bg-card-bg p-8 rounded-xl border border-gray-100 relative overflow-hidden" data-id="element-21">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-gray-300" data-id="element-22"></div>
            <h3 className="text-xl font-bold mb-4" data-id="element-23">Internal</h3>
            <div className="flex items-center text-lg text-text-muted" data-id="element-24">
              <span className="font-medium text-text-main mr-2" data-id="element-25">
                Fast & cheap
              </span>
              , but low engagement
              <X className="w-5 h-5 text-roche-red ml-3" strokeWidth={3} data-id="element-26" />
            </div>
          </div>
        </motion.div>

        {/* Right Side: Snakker */}
        <motion.div className="relative h-full flex flex-col justify-center" initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-27">
          <h2 className="text-2xl font-semibold text-roche-red mb-6 uppercase tracking-wider text-sm" data-id="element-28">
            Snakker
          </h2>

          <div className="bg-white p-10 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 relative z-10" data-id="element-29">
            <div className="space-y-6" data-id="element-30">
              {[{
              label: 'Fast',
              delay: 0.6
            }, {
              label: 'Good',
              delay: 0.8
            }, {
              label: 'Scalable',
              delay: 1.0
            }].map((item, i) => <motion.div key={i} className="flex items-center text-2xl font-bold" initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.4,
              delay: item.delay
            }} data-id="element-31">
                  <div className="w-8 h-8 rounded-full bg-roche-red/10 flex items-center justify-center mr-4" data-id="element-32">
                    <Check className="w-5 h-5 text-roche-red" strokeWidth={3} data-id="element-33" />
                  </div>
                  {item.label}
                </motion.div>)}
            </div>
          </div>

          {/* Abstract Triangle Background */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full -z-10 opacity-10 pointer-events-none flex items-center justify-center" data-id="element-34">
            <svg viewBox="0 0 200 200" className="w-96 h-96" data-id="element-35">
              <motion.polygon points="100,20 180,160 20,160" fill="none" stroke="var(--roche-red)" strokeWidth="4" initial={{
              pathLength: 0
            }} animate={{
              pathLength: 1
            }} transition={{
              duration: 1.5,
              delay: 0.5,
              ease: 'easeInOut'
            }} data-id="element-36" />
            </svg>
          </div>
        </motion.div>
      </div>

      <motion.div className="slide-punchline" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 1.2
    }} data-id="element-37">
        We remove the trade-off.
      </motion.div>
    </div>;
}